// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"37e30e99","389":"3afa0d6b","732":"3f93269e","977":"4181e485"}[chunkId] + ".chunk.js";
};